import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapContainer" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "midTitle" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "bigTitle mt-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "midTitle" }, "Abbiamo bisogno del tuo indirizzo da inserire sulla ricevuta")
], -1)
const _hoisted_9 = { class: "text-center mt-1" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "midTitle" }, "Abbiamo bisogno del codice fiscale per la ricevuta")
], -1)
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "text-center mt-1" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Indirizzo per la ricevuta: ")
const _hoisted_19 = { class: "text-center mt-1" }
const _hoisted_20 = {
  key: 3,
  class: "d-flex justify-content-around mt-4"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_22 = {
  key: 6,
  class: "form-group"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, " Invieremo le coordinate per effettuare il bonifico a questo indirizzo mail. Se devi modificarlo, clicca su \"Modifica email\". ", -1)
const _hoisted_24 = { class: "form-control" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "text-center mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_op_address = _resolveComponent("op-address")!
  const _component_stripe_form = _resolveComponent("stripe-form")!
  const _component_paypal_form = _resolveComponent("paypal-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offers, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "wrapSpacer",
          key: item.identifier
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["offerBox", { selected: _ctx.selectedOffer == item }]),
            onClick: ($event: any) => (_ctx.setOffer(item))
          }, [
            _createElementVNode("div", {
              class: "offerImage mb-2",
              style: _normalizeStyle('background-image: url(' + item.imgUrl + ');')
            }, null, 4),
            _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.subTitle), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.preziario[_ctx.$store.state.user.personalData.nazione.toLowerCase()].importo) + " " + _toDisplayString(item.preziario[_ctx.$store.state.user.personalData.nazione.toLowerCase()].simbolo), 1)
          ], 10, _hoisted_2)
        ]))
      }), 128))
    ]),
    (_ctx.selectedOffer && _ctx.shopCategory)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (!_ctx.indirizzoOk)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_op_address, {
                  modelValue: _ctx.$store.state.user.fiscalData.fiscalAddress,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$store.state.user.fiscalData.fiscalAddress) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.indirizzoNext && _ctx.indirizzoNext(...args))),
                    class: "btn btn-primary",
                    disabled: !_ctx.canIndirizzoOk
                  }, " Avanti ", 8, _hoisted_10)
                ])
              ]))
            : (!_ctx.codiceFiscaleOk)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.$store.state.user.fiscalData.codiceFiscale) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.$store.state.user.fiscalData.codiceFiscale]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.codiceFiscaleNext && _ctx.codiceFiscaleNext(...args))),
                      class: "btn btn-primary",
                      disabled: !_ctx.canCodiceFiscaleOk
                    }, " Avanti ", 8, _hoisted_15)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.$store.state.user.fiscalData.fiscalAddress.typedAddress), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary btn-sm",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.indirizzoOk = false; _ctx.metodoPagamento = ''})
                    }, " Modifica ")
                  ])
                ])),
          (_ctx.indirizzoOk)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_ctx.canBonifico)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass(["btn btn-primary", { disabled: _ctx.metodoPagamento != 'bonifico' }]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.metodoPagamento = 'bonifico'))
                    }, " Paga con bonifico ", 2))
                  : _createCommentVNode("", true),
                (_ctx.canCarta)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: _normalizeClass(["btn btn-primary", { disabled: _ctx.metodoPagamento != 'carta' }]),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.metodoPagamento = 'carta'))
                    }, " Paga con carta ", 2))
                  : _createCommentVNode("", true),
                (_ctx.canPayPal)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: _normalizeClass(["btn btn-primary", { disabled: _ctx.metodoPagamento != 'paypal' }]),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.metodoPagamento = 'paypal'))
                    }, " Paga con Paypal ", 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _hoisted_21,
          (_ctx.metodoPagamento == 'carta')
            ? (_openBlock(), _createBlock(_component_stripe_form, {
                key: 4,
                "user-name": _ctx.$store.state.user.personalData.completeName,
                "stripe-key": _ctx.shopCategory.stripePublicKey,
                "intent-cb": _ctx.intentCbStripe,
                onComplete: _ctx.onPayCompleteCard
              }, null, 8, ["user-name", "stripe-key", "intent-cb", "onComplete"]))
            : (_ctx.metodoPagamento == 'paypal')
              ? (_openBlock(), _createBlock(_component_paypal_form, {
                  key: 5,
                  "client-id": _ctx.shopCategory.payPalClientId,
                  "currency-cb": _ctx.currencyCbPayPal,
                  "intent-cb": _ctx.intentCbPayPal,
                  onComplete: _ctx.onPayCompletePaypal
                }, null, 8, ["client-id", "currency-cb", "intent-cb", "onComplete"]))
              : (_ctx.metodoPagamento == 'bonifico')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", null, [
                      (_ctx.modificaMail)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "email",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tempMail) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.tempMail]
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-success",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveMail && _ctx.saveMail(...args)))
                            }, "Salva")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$store.state.user.contactData.email), 1),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary btn-sm mt-1",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.modificaMail = true))
                              }, "Modifica email")
                            ])
                          ], 64))
                    ]),
                    _hoisted_26,
                    (!_ctx.modificaMail)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.payBonifico && _ctx.payBonifico(...args)))
                          }, "Conferma pagamento con bonifico!")
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}